<template>
  <a-row justify="center">
    <a-col :xxl="6" :xl="12" :md="12" :sm="18">
      <AuthWrapper>
        <div class="ninjadash-authentication-top">
          <h2 class="ninjadash-authentication-top__title">Entrar</h2>
        </div>
        <div class="ninjadash-authentication-content">
          <a-form 
            @finish="handleSubmit" 
            :model="formState"
            :rules="rules" 
            layout="vertical">
            <a-form-item name="email" label="E-mail">
              <a-input type="email" 
                ref="email" 
                v-model:value="formState.email" 
                placeholder="nome@exemplo.com"
                name="email"
                autocomplete="email" />
            </a-form-item>
            <a-form-item name="password" label="Senha">
              <a-input-password
                v-model:value="formState.password"
                placeholder="Senha"    
                name="password"            
              />
            </a-form-item>
            <div class="ninjadash-auth-extra-links">
              <a-checkbox @change="onChange">Manter logado</a-checkbox>
              <router-link class="forgot-pass-link" to="/auth/forgotPassword">
                Esqueceu a senha?
              </router-link>
            </div>
            <a-form-item>
              <sdButton class="btn-signin" htmlType="submit" type="primary">
                {{ isLoading ? "Validando dados..." : "Entrar" }}
              </sdButton>
            </a-form-item>
          </a-form>
        </div>
        <div class="ninjadash-authentication-bottom">
          <p>
            Ainda não tem uma conta?<router-link to="/auth/register"
              >Cadastre-se</router-link
            >
          </p>
        </div>
      </AuthWrapper>
    </a-col>
  </a-row>
</template>
<script>
import { computed, reactive, ref, defineComponent } from "vue";
import { useStore } from "vuex";
import { AuthWrapper } from "./style";
import { useRouter } from "vue-router";
import { notification } from "ant-design-vue";

const SignIn = defineComponent({
  name: "SignIn",
  components: { AuthWrapper },
  setup() {
    const { state, dispatch } = useStore();
    const isLoading = computed(() => state.auth.loading);
    const checked = ref(null);
    const router = useRouter();

    const rules = {
      password: [
        {
          required: true, 
          message: 'Preencha com a sua senha'
        },
      ],
      email: [
        {
          required: true,
          message: 'Preencha com o seu email',
          type: 'email',
        },
      ],
    }

    const handleSubmit = async () => {
      await dispatch("login", formState);
      if (state.auth.login) 
        await router.push("/");
      else {
        state.auth.error.forEach(element => {
          notification['error']({
            message: 'Login',
            description: element.message,
            duration: 5,
            placement: "bottomRight"})
          });
      }
    };
    
    const onChange = (checked) => {
      checked.value = checked;
    };

    const formState = reactive({
      email: "",
      password: "",
    });

    return {
      isLoading,
      checked,
      handleSubmit,
      onChange,
      formState,
      rules
    };
  },
  mounted() {
    this.$refs.email.focus()
  }
});

export default SignIn;
</script>
